import React from 'react';
import { Box, ColumnLayout, Container, Header } from '@amzn/awsui-components-react-v3/polaris';

/**
 * A "Details" container listing labelled values in four columns. Used by the TER group and
 * pricing model pages.
 */

export interface DetailsItem {
  label: string;
  value: React.ReactNode;
}

const DetailsPanel = ({ items }: { items: DetailsItem[] }): JSX.Element => (
  <Container header={<Header variant="h2">Details</Header>}>
    <ColumnLayout columns={4} variant="text-grid">
      {items.map(({ label, value }) => (
        <div key={label}>
          <Box variant="awsui-key-label">{label}</Box>
          <div>{value}</div>
        </div>
      ))}
    </ColumnLayout>
  </Container>
);

export default DetailsPanel;
